import Cookies from "js-cookie";

export const ajaxErrorRedirect = (data) => {
    if (data && data.responseJSON && (data.responseJSON.status === 401 || data.responseJSON.status === 403 || data.status === 401 || data.status === 403)) {
        Cookies.remove('site_builder_token', null);
        window.location.pathname = "/auth"
    }
};
